export const ROOT = 'MyAccount/listAvailable/announcementDetail';

export const FETCH_ANNOUNCEMENT_DETAIL_REQUEST = `${ROOT}/FETCH_ANNOUNCEMENT_DETAIL_REQUEST`;
export const FETCH_ANNOUNCEMENT_DETAIL_FAILURE = `${ROOT}/FETCH_ANNOUNCEMENT_DETAIL_FAILURE`;
export const FETCH_ANNOUNCEMENT_DETAIL_SUCCESS = `${ROOT}/FETCH_ANNOUNCEMENT_DETAIL_SUCCESS`;